export default __webpack_public_path__ + "assets/thunderstorms-day-rain.db6e82d0.svg";